import React from 'react';

import styled from 'styled-components';

import { skeletonGradient } from '~/searchCio/utils/styles';
import { mobile } from '~/techstyle-shared/react-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;

  ${mobile`
    gap: 8px;
  `}
`;

const Placeholder = styled.div`
  ${skeletonGradient}
`;

const FirstPlaceholder = styled(Placeholder)`
  height: 32px;
  width: 75%;
`;

const LargePlaceholder = styled(Placeholder)`
  height: 32px;
  width: 100%;
`;

const TextListSkeletonLoaderDesktop = () => {
  return (
    <Wrapper>
      <FirstPlaceholder />
      <LargePlaceholder />
      <LargePlaceholder />
      <LargePlaceholder />
    </Wrapper>
  );
};

export default TextListSkeletonLoaderDesktop;
